/**
 * @module sse/sse
 */
/**
 * @typedef {object} sse
 * @property {EventSource} source The EventSource
 * @property {string} uid The EventSource request uid
 */
import object from '../utils/object.js'
import sharing, { release } from '../utils/sharing.js'

const { EventSource } = globalThis

/**
 * Releases the EventSource for the provided request uid
 * @param {EventSource} source
 * @param {string} uid
 */
export { release }

/**
 * Registers an EventSource request
 * @param {string} url
 * @return {sse}
 */
export default (
  url
) => {
  const [uid, source] = sharing(EventSource, url)
  
  return object(null, { source, uid })
}
